<template>
  <div class="popover-menu-text">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PopoverMenuText',
});
</script>

<style lang="scss">
@use 'settings/colors';
.popover-menu-text {
  font-size: 13px;
  line-height: 1.5;
  padding: 4px 6px;
  color: colors.$color-grey-500;
}
</style>
